import React, { PropsWithChildren } from "react"

import { useCustomerInfo } from "./context"

export const CustomerInfoGuard = ({children}: PropsWithChildren) => {

  const { data } = useCustomerInfo()

  return <>{data !== null ? children : null}</>
}
